import {
  Col,
  Form,
  Input,
  Row,
  message,
  Select,
} from "antd";
import { AppButton, AppInput } from "components/antd-ui";
import { Rule } from "antd/lib/form";
import { authApi } from "api/auth.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import { Gender } from "constant";
import dayjs, { Dayjs } from "utils/dayjs";
import { useEffect, useState } from "react";
import { Customer } from "types/customer";
import { getTitle } from "utils";

const rules: Rule[] = [{ required: true, message: "Bắt buộc" }];

interface ShopAccountForm {
  username: string;
  password: string;
  ownerName: string;
  ownerEmail: string;
  ownerDob: string | Dayjs;
  ownerPhone: string;
  ownerGender: Gender;
  ownerBornPlace: string;
  ownerAvatar: string;
}

export const AccountPage = ({ title = "" }) => {
  const [form] = Form.useForm<ShopAccountForm>();
  const [loading, setLoading] = useState(false);
  const [ownerCustomer, setOwnerCustomer] = useState<Customer | null>(null);

  useEffect(() => {
    document.title = getTitle(title);
    fetchShop();
  }, []);

  const fetchShop = async () => {
    const res = await authApi.profile();
    form.setFieldsValue({
      username: res.data.username,
      password: "",
    });
    setOwnerCustomer(res.data.customer);
  };

  const handleSubmit = async () => {
    await form.validateFields();
    const ownerDob = form.getFieldValue("ownerDob");
    const data = {
      shop: {
        ...form.getFieldsValue(),
        ownerDob: dayjs(ownerDob).format("DD/MM/YYYY"),
      },
    };

    setLoading(true);
    try {
      await authApi.updateProfile(data);
      message.success("Cập nhật thành công");
      form.setFieldsValue({ password: "" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form layout="vertical" form={form}>
      <div className="app-page-form">
        <div className="app-page-form__row">
          <section className="app-page-form__section">
            <h3 className="app-page-form__section-header">Tài khoản</h3>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Tên tài khoản" name="username" rules={rules}>
                  <AppInput placeholder="Nhập tên tài khoản" />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Mật khẩu"
                  name="password"
                  tooltip={{ title: "Để trống sẽ không cập nhật" }}
                >
                  <AppInput
                    inputType="password"
                    placeholder="Nhập mật khẩu mới"
                  />
                </Form.Item>
              </Col>
            </Row>
          </section>

          <section className="app-page-form__section">
            <h3 className="app-page-form__section-header">Thông tin sở hữu</h3>

            {ownerCustomer && (
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Họ tên">
                    <Input
                      disabled
                      value={ownerCustomer.firstName}
                      placeholder=""
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Ngày sinh">
                    <Input
                      disabled
                      value={ownerCustomer.dob}
                      placeholder=""
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Giới tính">
                    <Select
                      disabled
                      value={ownerCustomer.gender}
                      style={{ width: "100%" }}
                    >
                      <Select.Option value={Gender.Male}>Nam</Select.Option>
                      <Select.Option value={Gender.FeMale}>Nữ</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Quê quán">
                    <Input
                      disabled
                      placeholder=""
                      value={ownerCustomer.address}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Số điện thoại">
                    <Input
                      disabled
                      value={ownerCustomer.phone}
                      placeholder=""
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Email">
                    <Input
                      disabled
                      placeholder=""
                      value={ownerCustomer.email}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item shouldUpdate={true}>
                    {() => (
                      <Form.Item label="Avatar" name="ownerAvatar">
                        <SingleImageUpload
                          disabled
                          onUploadOk={(path: string) => {
                            form.setFieldsValue({ ownerAvatar: path });
                          }}
                          imageUrl={ownerCustomer.avatar}
                        />
                      </Form.Item>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            )}
          </section>
        </div>

        <div className="app-page-form__footer">
          <AppButton
            tone="primary"
            loading={loading}
            onClick={handleSubmit}
          >
            Cập nhật tài khoản
          </AppButton>
        </div>
      </div>
    </Form>
  );
};
